import { NgModule } from '@angular/core';
import { AgGridAddPagingPanelDirective } from '@iris/common/modules/grid/ag-grid/extensions/pagination/add-paging-panel.directive';
import { AgGridPagingPanelComponentModule } from '@iris/common/modules/grid/ag-grid/extensions/pagination/paging-panel.component';

const PUBLIC_DECLARATIONS = [
  AgGridAddPagingPanelDirective,
];

@NgModule({
  imports: [
    AgGridPagingPanelComponentModule,
  ],
  declarations: [
    ...PUBLIC_DECLARATIONS,
  ],
  exports: [
    ...PUBLIC_DECLARATIONS,
  ],
})
export class AgGridPaginationModule {
}
